import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📘',
  number: 'Tomo 1',
  title: 'Biología y Fisiología Humana',
  subtitle: 'La máquina más perfecta del universo, explicada para el aula',
  problem: 'El primer contacto con el cuerpo humano puede ser el más fascinante o el más aburrido de la carrera escolar. Este tomo convierte un tema técnico en algo asombroso y relevante para tus alumnos desde el primer día.',
  bullets: ['Cómo está organizado el cuerpo humano y por qué esa organización es extraordinaria', 'Los niveles de organización biológica explicados con analogías que funcionan en el aula latinoamericana', 'Las células, los tejidos y la homeostasis explicados paso a paso', 'El sistema osteoarticular: por qué el hueso está vivo, cómo funciona la articulación y cómo prevenir lesiones reales en adolescentes', 'El sistema muscular: contracción, postura y el impacto real del uso del celular en la columna', 'El sistema cardiorrespiratorio: el corazón, los vasos, los pulmones y la prevención cardiovascular desde la adolescencia'],
  result: 'Tus alumnos entienden el cuerpo humano no como una lista de nombres para memorizar sino como la máquina más sofisticada del universo que habitan las 24 horas del día.'
}, {
  icon: '📗',
  number: 'Tomo 2',
  title: 'Nutrición y Metabolismo Energético',
  subtitle: 'La química de la vida aplicada al aula',
  problem: 'La nutrición es uno de los temas que más interesa a los adolescentes pero también uno de los más llenos de mitos y confusiones. Este tomo te da el material para enseñarlo con rigor científico y conexión real con la vida cotidiana.',
  bullets: ['Los macronutrientes: carbohidratos, proteínas y lípidos explicados en profundidad y con conexión directa a las decisiones alimentarias de los estudiantes', 'Los micronutrientes y el agua: por qué importan, de dónde vienen y qué pasa cuando faltan', 'El metabolismo energético: cómo el cuerpo transforma los alimentos en energía', 'Obesidad, diabetes, trastornos de la conducta alimentaria y desnutrición en el contexto latinoamericano'],
  result: 'Tus alumnos dejan de ver la nutrición como una lista de alimentos buenos y malos y empiezan a entender la bioquímica de las decisiones que toman todos los días.'
}, {
  icon: '📕',
  number: 'Tomo 3',
  title: 'El Sistema de Control e Inmunidad',
  subtitle: 'El cerebro, las hormonas y las defensas del cuerpo',
  problem: 'Este es el tomo que más engancha a los adolescentes porque habla directamente de ellos: de cómo funciona su cerebro en desarrollo, por qué actúan como actúan y cómo el estrés, el sueño y las emociones afectan su salud real.',
  bullets: ['El sistema nervioso: desde la neurona hasta la corteza prefrontal, con explicación de por qué el cerebro adolescente funciona diferente', 'Los sentidos, el dolor y la salud mental: ansiedad, depresión y bienestar en adolescentes latinoamericanos', 'El sistema endocrino: hormonas, glándulas y la pubertad explicada con precisión y sin tabúes', 'El sistema inmune: inmunidad innata, adaptativa, vacunas, alergias y enfermedades autoinmunes', 'La integración neuroendocrinoinmune: estrés, sueño, eje intestino-cerebro y bienestar adolescente'],
  result: 'Tus alumnos comprenden por qué duermen mal, por qué el estrés los enferma y por qué las vacunas funcionan. Y eso cambia su relación con su propia salud para siempre.',
  popular: true
}, {
  icon: '📔',
  number: 'Tomo 4',
  title: 'Salud Sexual, Prevención y Cuidado Integral',
  subtitle: 'Educación para la vida: cuerpo, decisiones y bienestar',
  problem: 'El tomo más necesario y el menos enseñado con rigor en América Latina. Este material aborda la salud sexual con precisión científica, respeto por la diversidad y enfoque de derechos. Sin tabúes, sin juicios, con información que los estudiantes necesitan para tomar decisiones informadas.',
  bullets: ['El sistema reproductor humano: anatomía, fisiología y el ciclo menstrual explicados con profundidad', 'La fecundación y el desarrollo embrionario temprano', 'Salud sexual y reproductiva: métodos anticonceptivos, ITS y prevención', 'Prevención de enfermedades no transmisibles: cáncer, diabetes, enfermedades cardiovasculares', 'El cuidado integral de la salud: higiene, ergonomía, adicciones y hábitos protectores', 'Primeros auxilios básicos para el docente'],
  result: 'Tus alumnos tienen la información precisa, completa y basada en evidencia que necesitan para cuidarse, respetarse y tomar decisiones responsables sobre su salud.'
}];
export function TomosSection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-292">
      <div className="max-w-6xl mx-auto" data-id="element-293">
        <div className="text-center mb-16" data-id="element-294">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-green-dark" data-id="element-295">
            📘 Los 4 Tomos del Mega Pack
          </h2>
          <p className="text-xl text-green-emerald" data-id="element-296">
            Material completo para el aula
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-297">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className={`bg-cream-card rounded-2xl border ${tomo.popular ? 'border-green-emerald shadow-[0_0_30px_rgba(5,150,105,0.15)]' : 'border-green-emerald/20 shadow-sm'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-298">
              {tomo.popular && <div className="absolute top-6 right-[-35px] bg-green-emerald text-white font-bold text-xs py-1 px-10 rotate-45 shadow-lg" data-id="element-299">
                  EL MÁS POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-300">
                <span className="text-4xl" data-id="element-301">{tomo.icon}</span>
                <div data-id="element-302">
                  <div className="text-green-emerald font-bold text-sm uppercase tracking-wider" data-id="element-303">
                    {tomo.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-green-dark" data-id="element-304">
                    {tomo.title}
                  </h3>
                </div>
              </div>

              <p className="text-ink font-medium mb-6 italic border-l-2 border-green-emerald/50 pl-4" data-id="element-305">
                {tomo.subtitle}
              </p>

              <div className="mb-6" data-id="element-306">
                <h4 className="text-sm font-bold text-ink-muted uppercase tracking-wider mb-2" data-id="element-307">
                  ¿Qué resuelve en el aula?
                </h4>
                <p className="text-ink-muted text-sm leading-relaxed" data-id="element-308">
                  {tomo.problem}
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-309">
                {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-310">
                    <CheckCircle2 size={18} className="text-green-emerald shrink-0 mt-0.5" data-id="element-311" />
                    <span className="text-ink-muted text-sm" data-id="element-312">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-green-veryLight border border-green-emerald/30 rounded-xl p-4 mt-auto" data-id="element-313">
                <span className="text-green-emerald font-bold block mb-1" data-id="element-314">
                  Resultado:
                </span>
                <p className="text-ink text-sm" data-id="element-315">{tomo.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}